import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Pagination from "./pagination";

const PaginationByApi = ({
    itemsCount,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    alwaysShown = true
}) => {
    const pagesCount = Math.ceil(itemsCount / itemsPerPage) || 0;
    const isPaginationShown = alwaysShown ? true : pagesCount > 1;

    useEffect(() => {
        if (pagesCount > 0 && currentPage > pagesCount) {
            setCurrentPage(pagesCount);
        }
    }, [pagesCount, currentPage, setCurrentPage]);

    if (!isPaginationShown || !itemsCount) {
        return null;
    }

    return (
        <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={itemsCount}
            pageSize={itemsPerPage}
            onPageChange={setCurrentPage}
        />
    );
};

PaginationByApi.propTypes = {
    itemsCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    setCurrentPage: PropTypes.func.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    alwaysShown: PropTypes.bool
};

export default PaginationByApi;
